module.exports = __webpack_public_path__ + "img/pro_beijia_05.ab30d7f3.png";